import { render, staticRenderFns } from "./InventoryAlerts.html?vue&type=template&id=e0c42716&scoped=true&external"
import script from "./InventoryAlerts.js?vue&type=script&lang=js&external"
export * from "./InventoryAlerts.js?vue&type=script&lang=js&external"
import style0 from "./InventoryAlerts.vue?vue&type=style&index=0&id=e0c42716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c42716",
  null
  
)

export default component.exports